import React, { Component, useEffect } from 'react'
import { connect } from 'react-redux'
import * as actionCreators from '../../store/actions/index'
import { Link } from 'react-router-dom'
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from "@material-ui/core/Tooltip";
import TablePagination from '@material-ui/core/TablePagination';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Popper from '@material-ui/core/Popper';
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import MenuList from '@material-ui/core/MenuList';
import MenuItem from '@material-ui/core/MenuItem';
import swal from 'sweetalert'
import OutlinedInput from '@material-ui/core/OutlinedInput';
import VisibilityOffOutlinedIcon from '@material-ui/icons/VisibilityOffOutlined';
// import Alert from '@material-ui/lab/Alert';
import InputAdornment from '@material-ui/core/InputAdornment';
import Select from '@material-ui/core/Select';
import moment from 'moment'
import InputBase from '@material-ui/core/InputBase';
import ReactPaginate from 'react-paginate';
import FormControl from '@material-ui/core/FormControl';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import { Grid } from '@material-ui/core';
import axios from '../../http-config'
import { STATEDASHBOARDUSER } from '../../../src/config/constant'
import UserForm from './UserForm'
import { useTranslation } from 'react-i18next';
// import * as actionCreators from '../../store/actions/index'

export const UserListing = (props) => {
    const {t} = useTranslation()
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [open, setOpen] = React.useState(false);
    const [id, setId] = React.useState('');
    const [limit,setLimit] = React.useState(10);
    const [page,setPage] = React.useState(0);
    const [sortName, setSortName] = React.useState('')
    const [sortValue, setSortValue] = React.useState('asc')
    const [filterValue , setfilterValue] = React.useState('')
    const [openNewUser, setopenNewUser]= React.useState(false)

    const [username, SetUsername] =  React.useState('')
    const [email , SetEmail] =  React.useState('')
    const [role, setRole] = React.useState('')
    const [ulb, setUlb] = React.useState('')
    const [roleOptions, setRoleOptions] = React.useState([])
    const [ulbOptions, setUlbOptions] = React.useState([])
    const [usernameErr, setusernameErr] = React.useState('')
    const [emailErr, setEmailErr] =  React.useState('')
    const [roleErr, setRoleErr] = React.useState('')
    const [ulbErr, setulbErr] = React.useState('')
    const [roleName, setroleName] =  React.useState('')
    const [dashboard, setdashboard] = React.useState('')
    const [statedashboard, setstatedashboard] = React.useState('')
    const [ulbManagement, setulbManagement] =  React.useState('')
    const [userManagement, setuserManagement] = React.useState('')
    const [propertyManagement, setpropertyManagement] = React.useState('')
    const [loadsRecords, setloadsRecords] = React.useState('')
    const [ScheduleProperties, setScheduleProperties] = React.useState('')
    const [TreatmentFacilities, setTreatmentFacilities] =React.useState('')
    const [OperatorManagement, setOperatorManagement] = React.useState('')

    const [searchBy , setSearchBy] =  React.useState('selectName')
    const [roleOpen, setroleOpen] = React.useState('')
    const [anchorEl_bulk_property, setanchorEl_bulk_property] = React.useState(null)
    const [placement_property, setplacement_property] =  React.useState("")
    const [open_bulk_property, setopen_bulk_property] =React.useState(false)
    const [ openRolePopup, setopenRolePopup] = React.useState(false)
    const [openNewRoleAdd, setopenNewRoleAdd]= React.useState(false)
    const [roleNameAdd, setroleNameAdd]= React.useState("")
    const [accessSite , setAccessSite] = React.useState("")
    const [roleNameAddErr, setroleNameAddErr] = React.useState("")
    const [accessSiteErr, setaccessSiteErr] =  React.useState("")
    const [appAccess, setAppAccess] = React.useState(false)
    const [webAccess, setwebAccess] = React.useState(false)
    const [openIdPop, setopenIdPop] = React.useState('')
    const [edituserName, setedituserName] = React.useState('')
    const [editEmail , SeteditEmail] =  React.useState('')
    const [editRole, seteditRole] = React.useState('')
    const [editUlb, setEditUlb] = React.useState('')
    const [editunAssignable, seteditunAssignable] = React.useState('')
    const [unAssignable, seteunAssignable] = React.useState('')
    const [openEditUser, setopenEditUser]=React.useState(false)
    const [  isPasswordShown, setisPasswordShown] =React.useState(false)
    const [password, setpassword] =React.useState("")
    const [passwordErr, setpasswordErr] =React.useState("")
    const [activePage, setactivePage] = React.useState(0)
    // const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [controls, setControls] = React.useState({ search: {
        value: '',
    }})
    const [currentSortId, setCurrentSortId] = React.useState('')

    useEffect(() => {
        props.onFetchUserHeaders(props.token)
        props.onFetchUserListing({token: props.token,limit:limit,page:page,sortName: sortName,sortValue: sortValue,  searchQuery:controls.search.value,   roleFilter:filterValue })
        props.onFetchRole({sortName: '',sortValue : '',token: props.token,limit:limit,page:page,})


        axios({
            method: 'get',
            url: `/role/?admin=${true}`,
            headers: { 'Authorization': `Bearer ${props.token}` }
        })
            .then((response) => {
                setRoleOptions( response.data.data )
            })
        axios({
            method: 'get',
            url: `ulb`,
            headers: { 'Authorization': `Bearer ${props.token}` }
        })
            .then((response) => {
                setUlbOptions( response.data.data.ulbs )  
            })  
    }, [])
    const handleClickMoreVertIcon = (event,id, userName, email, role, ULBId, unAssignable) => {
        setOpen(!open)
        setAnchorEl(event.currentTarget)
        setId(id)
        setedituserName(userName)
        SeteditEmail(email)
        seteditRole(role)
        setEditUlb(ULBId)
        seteditunAssignable(unAssignable)
    }
    const handleClickAwayEdit = () => {
        setOpen(false)
    };
    const handleDelete = (id) => {
        const payload = {
            id : id,
            sortName: sortName,
            sortValue: sortValue,
            token: props.token,
            page:  page,
            limit: limit,
            searchQuery:controls.search.value ,
            roleFilter:filterValue
            
        }
        const data = {
            id : id, 
        }
        props.onDeleteUser(payload, data, props, t)
    }

    const  handleChange = (e) => {
        if(e.target.name == "username"){
            SetUsername(e.target.value)
        }
        if(e.target.name == "email"){
            SetEmail(e.target.value)
        }
        if(e.target.name == "role"){
            setRole(e.target.value)

        }
        if(e.target.name == "ulb"){
            setUlb(e.target.value)
        }
        if(e.target.name == "password"){
            setpassword(e.target.value)
        }
      
    }
    const handleChecked = (e) => {
        // console.log(e.target.name,  e.target.checked,"cjeckkk")
        // this.setState({ [e.target.name]: e.target.checked })
    }
    const handlePageClick = (e) => {
        const selectedPage = e.selected;
    //  const  activePage1 =  e.selected;
     setactivePage( e.selected)
        setPage(selectedPage + 1)
        let payload = {
            token: props.token,
            page:  selectedPage + 1,
            limit: limit,
            sortName: sortName,
            sortValue: sortValue,
            searchQuery:controls.search.value,
            roleFilter:filterValue
        }
        props.onFetchUserListing(payload)
    };

  const  handleSort = (e,sortBy) => {
        let value
        if ( sortName=== sortBy.accessor) {
             value = (sortValue === 'desc') ? 'asc' : 'desc';
            setSortName( sortBy.accessor)
            setSortValue(value)
        } 
        else {
            setSortName( sortBy.accessor)
            setSortValue('desc')
            value = 'desc'
         }
         setCurrentSortId(sortBy.accessor)
        let payload = {
        token: props.token,
        sortName: sortBy.accessor,
        sortValue: value,
         page: page,
         limit: limit,
         searchQuery:controls.search.value,
         roleFilter:filterValue
        }

        props.onFetchUserListing(payload);
  
      }


   const handlePropertySearch = (e) => {
        e.preventDefault()
        let searchVal = controls.search.value
        setactivePage(0)
        // if(searchBy === "user"){
            if (!!searchVal && searchVal.length >= 2) {
                let payload = {
                    token: props.token,
                    searchQuery:searchVal,
                    limit:10,
                    page:1,
                    searchByField: searchBy,
                    sortName: sortName,
                    sortValue: sortValue,
                    roleFilter:filterValue
                  
                }
                props.onSearchUserName(payload, t)
            } else {
             
                swal(`${t("ulbSearch")}`)
            }
            
        // }
        // if(searchBy === "role"){
            
        // }
       
    }
  const  inputChangedHadler = (event, controlName) => {
        const updatedControls = {
            ...controls,
            [controlName]: {
                ...controls[controlName],
                value: event.target.value,
            }
        }
        setactivePage(0)
        setControls(updatedControls) ;
        if( updatedControls.search.value === ''){
            let payload = {
                token: props.token,
                searchQuery:'',
                limit:10,
                page:1,
                searchByField: searchBy,
                sortName: sortName,
                sortValue: sortValue,
                roleFilter:filterValue
            }
            props.onSearchUserName(payload, t) 
        }
   
    }
    const handleOpenNewUser = ()=>{
        setopenNewUser(true)
        // setopenIdPop('')
        // SetUsername('')
        // SetEmail('')
        // setRole('')
        // setUlb('')
    } 
    const handleCloseAdduser =(event)=>{
        setopenNewUser(false)
        setopenIdPop('')
        SetUsername('')
        SetEmail('')
        setRole('')
        setUlb('')
    }
    const handleCloseEdituser =()=>{
        setopenEditUser(false)
        setopenIdPop('')
        SetUsername('')
        SetEmail('')
        setRole('')
        setUlb('')
        setusernameErr('')
        setEmailErr('')
        setRoleErr('')
        setulbErr('')
        setpasswordErr('')
        setpassword('')

    }
   const  checkValidityUser = () => {
        let isError = false
        if (!username) {
            isError = true
            setusernameErr(`${t("required")}`)
            // this.setState({ usernameErr: '*This field is required' })
        }
        else if ((username.length > 0 && username.length < 3) || (username.length > 25)) {
            isError = true
            setusernameErr(`${t('ulbAdminErr')}`)
            // this.setState({ usernameErr: '*Name should be Minimum 3 characters and Maximum 25 characters' })
        }
        else {
            isError = false
            setusernameErr('')
            // this.setState({ usernameErr: '' })
        }
        if (!email) {
            setEmailErr(`${t("required")}`)
            // this.setState({ emailErr: '*This field is required' })
        }
        else if (email) {
            var mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
            if (!email.match(mailformat)) {
                isError = true
                setEmailErr(`${t("ulbEmailErr")}`)
                // this.setState({ emailErr: '*You have entered invalid email address' })
            }
            else {
                isError = false
                setEmailErr('')
                // this.setState({ emailErr: '' })
            }
        }
      
        if (!role) {
            isError = true
            setRoleErr(`${t("required")}`)
            // this.setState({ roleErr: "*This field is required" })
        }
        else {
            isError = false
            setRoleErr("")
            // this.setState({ roleErr: '' })
        }
        if (!(roleName == STATEDASHBOARDUSER) && !ulb) {
            isError = true
            setulbErr(`${t("required")}`)
            // this.setState({ ulbErr: "*This field is required" })
        }
        else {
            isError = false
            setulbErr('')
            // this.setState({ ulbErr: '' })
        }


        if(username && !password){
            isError = true
            setpasswordErr(`${t("required")}`)  
        }else{
            isError = false
            setpasswordErr('')  
        }
        if(username && password){
            if(!password.match(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/)){
                isError = true
               
                    setpasswordErr(`${t("ulbPassErr")}`)
              
            }else{
                isError = false
                setpasswordErr('')  
            }
        }
        return isError
    }
    const handleSubmitAdduser =(e)=>{
        e.preventDefault()
        const err = checkValidityUser()
        if (!err) {
            const formdata = {
                id : openIdPop,
                token: props.token,
                userName: username,
                email: email,
                roleId: role,
                ulbId: !(roleName == STATEDASHBOARDUSER) ? ulb : null,
                password: password
               
            }
            props.onEditUser(formdata,props, t)
            handleCloseEdituser();
            
    }
}
    const handleCloseAddRole = ()=>{
        setopenNewRoleAdd(false)
        setroleNameAdd('')
        setAccessSite('')
    }
    const handleChangeSearch =(e)=>{
        if(e.target.value == 'selectName'){
            props.onFetchUserListing({token: props.token,limit:limit,page:page,sortName: sortName,sortValue: sortValue,  searchQuery:controls.search.value,   roleFilter:filterValue })
            // setSearchBy('')
            // setControls.search.value('') ;
            const updatedControl1 = {
                
            search: {
                    
                    value: '',
                }
            }
            setControls(updatedControl1) ;
        }
        if(e.target.value == 'role'){
            // props.onFetchUserListing({token: props.token,limit:limit,page:page,sortName: sortName,sortValue: sortValue,  searchQuery:controls.search.value,   roleFilter:filterValue })
            // setSearchBy('')
            // setControls.search.value('') ;
            const updatedControl2 = {
            
                search: {
                    
                    value: '',
                }
            }
            setControls(updatedControl2) ;
        }
        if(e.target.value == 'user'){
            const updatedControl3 = {
             
                search: {
                    
                    value: '',
                }
            }
            setControls(updatedControl3) ;        }
        setSearchBy(e.target.value)
    }
   const ClickGetFilterVals = (e, colObj) => {
        let payload = {
            token: props.token,
            limit:limit,
            page:page,
            sortName: sortName,
            sortValue: sortValue, 
             searchQuery:controls.search.value,
            roleFilter:e
        }
      setfilterValue(e)
      props.onFetchUserListing(payload);

       }  



     const  handleClickProperty = (newPlacement) => (event) => {
        setanchorEl_bulk_property(event.currentTarget)
        setplacement_property(newPlacement)
        setopen_bulk_property(true)

        // this.setState({ anchorEl_bulk_property:event.currentTarget, placement_property:newPlacement, open_bulk_property:!this.state.open_bulk_property});
    }; 
    const handleClickAwayBulkProperty = () => {
        // this.setState({open_bulk_property: false});
        setopen_bulk_property(false)
    };  

    const handleCloseTablePop = ()=>{
        setopenRolePopup(false)
    }

  const handleAddnewRole =()=>{
    setopenNewRoleAdd(true)
  }
  const handleSubmitAddRole = ()=>{
      const err = checkValidity()
    if(!err){
        const payload = {
            name  : roleNameAdd.trim(),
            "roleAccess":{
                "IsMobileAppAccess":appAccess,
                "IsWebAppAccess":webAccess
            }
        }
        const payload2 = {
            token : props.token,
            page:page,
            limit:limit,
            sortName: "",
            sortValue :"",
        }
        props.onAddRole(payload, payload2)
        setopenNewRoleAdd(false)
        setroleNameAdd('')
        setAccessSite('')
        // this.setState({addNew: false, addDisabled: false, name : '', editRecord:false, accessSite:''})
    }
  }
  const handleChangeAddRole =(e)=>{
      
    if(e.target.name == 'roleNameAdd'){
        setroleNameAdd(e.target.value)
        checkValidity()
    }
    if(e.target.name == 'accessSite'){
        setAccessSite(e.target.value)
        checkValidity()
        if(e.target.value == 'App'){
            setAppAccess(true)
            setwebAccess(false)
        }
        if(e.target.value == 'web'){
            setwebAccess(true)
            setAppAccess(false)
        }
        if(e.target.value == 'both'){
            setwebAccess(true)
            setAppAccess(true)
        }
    }
  }
  const checkValidity =()=>{
    let isError = false
    if(!roleNameAdd){
        isError=true
        setroleNameAddErr('*This is required field.')
    }
    else if(roleNameAdd && roleNameAdd.trim().length < 5 || roleNameAdd.trim().length > 25){
        isError=true
        // this.setState({roleNameAddErr : '*between 5 to 25'})
        setroleNameAddErr('*between 5 to 25')
    }
    else if(roleNameAdd && roleNameAdd.trim().length >= 5 || roleNameAdd.trim().length <= 25){
        // this.setState({roleNameAddErr:''})
        setroleNameAddErr('')
    }

    if(!accessSite){
        isError=true
        setaccessSiteErr('*This is required field.')
    } else if(accessSite){
        setaccessSiteErr('')
    }
  
    return isError
}



const openPopeditUserDetals = (idss, name, email, role, ulb, unassigned)=>{
    
    setopenEditUser(true)
    setopenIdPop(idss)
    SetUsername(name)
    SetEmail(email)
    setRole(role)
    setUlb(ulb)
    seteunAssignable(unassigned)


}

const toggleVisibility=()=>{
    // const{isPasswordShown}=this.state
    // this.setState({isPasswordShown:!isPasswordShown})
    setisPasswordShown(!isPasswordShown)
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    // this.setState({page:newPage})
  };
 const  handleChangeRowsPerPage = (event) => {
    // this.setState({limit:parseInt(event.target.value, 10),page:0});
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
    
  };
    const gpsInstalledOptions=[
        {
            "key"    : 'web',
            "name"   : "Web"
        },
        {
            "key"    : 'App',
            "name"   : "Mobile Application"
        },
        {
            "key"    : 'both',
            "name"   : "Both"
        }
    
    ]

 
    const userHeaders = props.userHeaders.map(header => {
            let filterType;
            if( header.accessor == 'role'){
                header.filter = true
            }
            if(header.filter == true && header.accessor == 'role'){
                filterType = 
                // <label className="selectTag">
                <select 
                style={{
                    width: '22px',
                    borderColor:"white",
                    backgroundColor: 'LightGray !important',
                    outline:"none",
                    display: "flex",
                    alignItems: 'right',   
                  }}
                //   className="filter-ixo"
                value={filterValue}
                onChange={(e) => {
                    ClickGetFilterVals(e.target.value , header)
                }}
                >
                    <option value="">&nbsp;All&nbsp;</option>
                    { !!props.roleData&&props.roleData.map(data => {
                        if(data.name == 'Admin'){
                            return ''
                        }
                       return <option  value={data.roleId}>{data.name}</option>
                   })}
                  
                
                </select>
                // </label>
               
            }

        
        return(
            <TableCell key={header.header}>
            <div style={{
                display: 'flex',
                alignItems: 'start',
                whiteSpace: 'break-spaces',
                height: '3em'
            }}>
                {filterType}
                 {header.header}
           {header.header === "Action"? "":
                    <div onClick={(e) => handleSort(e,header)}>
                        <div>{
                            currentSortId===header.accessor? sortValue ==='asc'?(<ArrowDropDownIcon fontSize="small"/>):(<ArrowDropUpIcon fontSize="small"/>) :(<ArrowDropDownIcon fontSize="small"/>)
                        }
                        </div>  
                    </div>}
               
                {/* {filterType} */}
            </div>
                </TableCell>
        )
    })

// console.log(role,"role")
    
     const userData = !!props.userData&&props.userData.slice(page * limit, page * limit + limit).map((data, index) =>   {
        const ID = data['userId']
        const userName = data['userName']
        const email = data['email']
        const role= data['roleId']
        const ULBId = data['ULBId']
        const unAssignable = data['unAssignable']
    
        return(
            <TableRow key={data.userId}>
                {
                    props.userHeaders.map(header => {
                        if(header.accessor == 'actionButton'){
                            return <TableCell>
                                        <IconButton onClick={(e)=>handleClickMoreVertIcon(e,ID, userName, email, role, ULBId, unAssignable)}
                                                    aria-label="more"
                                                    id={ID}
                                                    aria-controls="long-menu"
                                                    aria-haspopup="true">
                                            <MoreVertIcon fontSize='small'/>  
                                        </IconButton>
                                        <Popper open={open} anchorEl={anchorEl}>
                                            <ClickAwayListener onClickAway={handleClickAwayEdit}>
                                                <Paper style={{boxShadow: "none",border: "1px solid rgb(61, 171, 53)"}}>
                                                    <MenuList>
                                                        <Link className='email_link'>
                                                         <MenuItem onClick={()=>openPopeditUserDetals(id, edituserName, editEmail, editRole, editUlb, editunAssignable)}>{t("edit")}</MenuItem>
                                                        </Link>
                                                        <MenuItem style = {{color: '#3dab35'}} onClick={() => {
                                                                swal({ title : `${t("ulbDeleteErr1")}`,
                                                                        text : `${t("ulbDeleteErr2")}`,
                                                                        icon : "warning",
                                                                        buttons : {
                                                                        cancel : 'No',
                                                                        confirm: 'Yes'}
                                                                })
                                                                .then((willDelete) => {
                                                                    if (willDelete) {
                                                                        handleDelete(id);
                                                                    } 
                                                                });
                                                            }}>{t("delete")}</MenuItem>
                                                    </MenuList>
                                                </Paper>
                                            </ClickAwayListener>
                                        </Popper>
                                </TableCell>
                        }
                        else if(header.accessor=='updatedAt'){
                               return <TableCell style={{
                                whiteSpace: "normal",
                                wordWrap: "break-word"
                              }} key={header.accessor} >{ moment(data[header.accessor]).format('DD-MMM-YYYY hh:mm a')}</TableCell>
                           }
                        else {
                            return (
                                <TableCell style={{
                                    whiteSpace: "normal",
                                    wordWrap: "break-word"
                                  }}>{data[header.accessor]}</TableCell>
                            )
                        }
                    })
                }
            </TableRow>
        )
    })
    return (
        <div>
            <div className="dashboard_right_content">
                <img className="dashboard_right_content_top_icon" src="images/Rectangle.svg" />
                <div className="dashboard_right_content_top">
                    <h5>{t("userManagement")}</h5>
                    <div className="dashboard_right_content_top_options">
                        <div>
                        <FormControl>
                            {/* <label className="required" htmlFor="searchBy">Search Property</label> */}
                            <Select value={searchBy}
                                onChange={handleChangeSearch}
                                name="searchBy"
                                style={{ width: '100%' ,  border:"1px solid #ccc", borderRadius:'5px'}}>
                                 <MenuItem value={"selectName"}>{`${t("select")}`}</MenuItem>
                                    <MenuItem value={"role"}>{`${t("byRole")}`}</MenuItem>
                                    <MenuItem value={"user"}>{`${t("byUser")}`}</MenuItem>
                                
                            </Select>
                            {/* <div style={{ fontSize: 12, color: "red", fontFamily: "'Open Sans', sans-serif", marginTop: "1%" }}>{ulbErr}</div> */}
                             </FormControl>
                        </div>
                   

                            <div className="dashboard_right_content_top_search">
                                <Paper component="form">
                                    <IconButton aria-label="menu">
                                        <img src="images/search_icon.svg" />
                                    </IconButton>
                                    <InputBase disabled={searchBy== "selectName"? true:false} onChange={(event) => inputChangedHadler(event, 'search')} placeholder={searchBy=="role"?"Role Name" :searchBy== 'user'? "User Name": searchBy== 'selectName'? '':''} />
                                    <Button onClick={handlePropertySearch} variant="contained" color="primary" type="submit" disabled={searchBy == "selectName"? true:false}>{t("search")}</Button>
                                </Paper>
                            </div>
                        <Button style={{width:'100%',}} onClick={handleOpenNewUser}>{t("addNewUser")}</Button>

                      <div>

                      <Button className="email_link"
                                // ref={anchorRef}
                                aria-controls={roleOpen ? 'menu-list-grow' : undefined}
                                aria-haspopup="true"
                                onClick={handleClickProperty('bottom')}
                                style={{height:'35px', marginLeft:'20px'}}>
                                {t("role")}
                                {
                                    roleOpen ?   <ArrowDropUpIcon /> : <ArrowDropDownIcon/> 
                                }
                                
                            </Button>
                            <Popper style={{zIndex:"10"}} open={open_bulk_property} anchorEl={anchorEl_bulk_property} placement={placement_property} transition>
                            {({ TransitionProps }) => (
                                    <ClickAwayListener onClickAway={handleClickAwayBulkProperty}>
                                <Paper style={{zIndex: 1, border:"1px solid #3dab35"}}>
                                    <MenuList>
                                    <Link to={'/role-management'} style={{textDecoration:'none' ,color:'#3DAB35'}}>
                                    <MenuItem  style={{ color:'#3dab35',fontSize:'small',align:'left', fontFamily: "'Open Sans', sans-serif"}}> 
                                            {t("viewRole")}
                                        </MenuItem> 
                                        </Link>  
                                 
                                        {/* <MenuItem  style={{ color:'#3dab35',fontSize:'small',align:'left', fontFamily: "'Open Sans', sans-serif"}} onClick={handleAddnewRole}> 
                                      Add New Role
                                  </MenuItem>  */}
                                    </MenuList>
                                </Paper>
                                </ClickAwayListener>
                            )}
                            </Popper>  

                      </div>
                    </div>
                </div>
            </div>
            
            <div className="ulb_listing " >
            {(!props.loadingUser)&& <div id="cover-spin"></div>}
                <TableContainer component={Paper} style={{paddingLeft:"15px",paddingRight:"15px"}}>
                    <Table stickyHeader aria-label="sticky table" style={{ tableLayout: 'fixed' }}>
                        <colgroup>
                            <col style={{width:'10%'}}/>
                            <col style={{width:'15%'}}/>
                            <col style={{width:'20%'}}/>
                            <col style={{width:'15%'}}/>
                            <col style={{width:'15%'}}/>
                            <col style={{width:'15%'}}/>
                            <col style={{width:'10%'}}/>  
                        </colgroup>
                        <TableHead >
                            <TableRow >
                            {userHeaders}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                                {/* {userData} */}
                                {userData.length === 0 ? <TableRow style={{textAlign:'center', fontWeight:'bold', fontSize: '13px', }}>
                                            No Records Found !!</TableRow>:userData }
                        </TableBody>
                    </Table>
                </TableContainer>
                {
                props.totalCount && props.totalCount != 0 && 
                    // <ReactPaginate
                    // previousLabel={"Prev"}
                    // nextLabel={"Next"}
                    // breakLabel={"..."}
                    // breakClassName={"break-me"}
                    // pageCount = {10}
                    // pageCount = {props.totalCount/limit}
                    // marginPagesDisplayed={2}
                    // pageRangeDisplayed={5}
                    // forcePage = {activePage}
                    // style={{borderLeftWidth:'0px'}}
                    // onPageChange={handlePageClick}
                    // containerClassName={"pagination"}
                    // subContainerClassName={"pages pagination"}
                    // activeClassName={"active"}/>
                    <TablePagination
                    rowsPerPageOptions={[10,50,100]}
                    colSpan={3}
                    count={props.totalCount}
                    component="div"
                    rowsPerPage={limit}
                    page={page}
                    SelectProps={{
                    inputProps: { 'aria-label': 'rows per page' },
                    native: true,
                    }}
                    labelRowsPerPage={t("rowsPerPage")}
                    containerClassName={"pagination"}
                    subContainerClassName={"pages pagination"}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                />
                }
            </div>   


    <UserForm open={openNewUser} idEdit={openIdPop} handleclose={handleCloseAdduser} userName={edituserName} email={editEmail} roleId={editRole} ULBId={editUlb}/>


    <div className="setFreq">
      <Dialog
        maxWidth={'md'}
        fullWidth={true} 
        // open={true}
        open={openEditUser}
        aria-labelledby="responsive-dialog-title">
        <DialogTitle className="text-center border-none " style={{color:'#3dab35'}}><span style={{fontSize:'18px'}}>{`${t("editUser")}`}</span></DialogTitle>
        <DialogContent > 
        <div className="create_ulb_content_outer">
                    <div className="create_ulb_content create_ulb_contentPop">
                        <Grid container spacing={1}>
                            <Grid item xs={6}>
                                <FormControl>
                                    <label className="required" htmlFor="username">{t("userName")}</label>
                                    <TextField id="username"
                                        variant="outlined"
                                        placeholder="Enter User Name"
                                        name="username"
                                        defaultValue={username}
                                        onChange={handleChange} />
                                    <div style={{ fontSize: 12, color: "red", fontFamily: "'Open Sans', sans-serif", marginTop: "1%" }}>{usernameErr}</div>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl>
                                    <label className="required" htmlFor="email">{t("email")}</label>
                                    <TextField id="email"
                                        variant="outlined"
                                        placeholder="Enter Email"
                                        name="email"
                                        defaultValue={email}
                                        onChange={handleChange} />
                                    <div style={{ fontSize: 12, color: "red", fontFamily: "'Open Sans', sans-serif", marginTop: "1%" }}>{emailErr}</div>
                                </FormControl>
                            </Grid>

                            <Grid item xs={6}>
                     <form autocomplete="off">
                      <FormControl>
                      <label className={username ? "required" : ''} htmlFor = "password">{t("userPass")}</label>
                      
                      <OutlinedInput id = "password" 
                                      variant="outlined" 
                                      placeholder={t("enterPass")} 
                                      name="password" 
                                      value={password}
                                      onChange={handleChange}
                                      type={isPasswordShown ? "text" : "password"}
                                      endAdornment={isPasswordShown ?
                                        (<InputAdornment position="end"><VisibilityOffOutlinedIcon 
                                        onClick={()=>{toggleVisibility()}}
                                        /></InputAdornment>) :
                                        (<InputAdornment position="end">
                                            <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={()=>{toggleVisibility()}}
                                            >
                                            <img src="images/eye.svg" />
                                        </IconButton> </InputAdornment> )    
                                        }
                                        // errortext={passwordError}    
                                      />
                                     
                          <div style={{fontSize:12,color:"red", fontFamily:"'Open Sans', sans-serif", marginTop:"1%"}}>{passwordErr}</div>
                  </FormControl>
                  </form>
                  
                    </Grid>
                            <Grid item xs={6} >
                                <FormControl>
                                    <label className="required" htmlFor="role">{t("role")}</label>
                                    {/* {
                                    unAssignable == true ?
                                            <TextField variant="outlined"
                                            defaultValue={role}
                                                disabled={true}
                                                style={{ width: '99%' }}
                                            />
                                            : */}
                                            <Select value={role}
                                                onChange={handleChange}
                                                name="role">
                                                {roleOptions.map((role) => (
                                                    <MenuItem value={role.roleId}>{role.name}</MenuItem>
                                                ))}
                                            </Select>
                                    {/* } */}

                                    <div style={{ fontSize: 12, color: "red", fontFamily: "'Open Sans', sans-serif", marginTop: "1%" }}>{roleErr}</div>
                                </FormControl>
                            </Grid>
                            {!(roleName == STATEDASHBOARDUSER) &&
                                <Grid item xs={6}>
                                    <FormControl>
                                        <label className="required" htmlFor="ulb">{t("ulb")}</label>
                                        <Select value={ulb}
                                            onChange={handleChange}
                                            name="ulb"
                                            style={{ width: '99%' }}>
                                            {ulbOptions.map((ulb) => (
                                                <MenuItem value={ulb.ulbId}>{ulb.name}</MenuItem>
                                            ))}
                                        </Select>
                                        <div style={{ fontSize: 12, color: "red", fontFamily: "'Open Sans', sans-serif", marginTop: "1%" }}>{ulbErr}</div>
                                    </FormControl>
                                </Grid>
                            }

                        </Grid>

                     

                    </div>
                </div>   
        </DialogContent>

        <DialogActions >
        <Grid container spacing={1}>
        <Grid item xs={12}>

            <div  className="create_ulb_buttons" style={{marginBottom:'10px'}}>
            <Button autoFocus onClick={handleCloseEdituser} style={{
                background:'none',
                color:'#3dab35',
                border:" 1px solid rgba(61, 171, 53, 0.5)",
                }} 
                type="submit">{t("cancel")}
            </Button>
            <Button onClick={handleSubmitAdduser} style={{
                background:'#3dab35',
                color:'white',
                border:" 1px solid rgba(61, 171, 53, 0.5)",
                }}  autoFocus
                type="submit"
                >{`${t("saveChange")}`}
            </Button>
            </div>
        </Grid>
        </Grid>
           
        </DialogActions>
    </Dialog>
    </div>







    <div className="setFreq">
      <Dialog
        maxWidth={'sm'}
        fullWidth={true} 
        // open={true}
        open={openNewRoleAdd}
        aria-labelledby="responsive-dialog-title">
        <DialogTitle className="text-center border-none " style={{color:'#3dab35'}}><span style={{fontSize:'18px'}}>Add New Role</span></DialogTitle>
        <DialogContent > 
        <div className="create_ulb_content_outer">
                    <div className="create_ulb_content create_ulb_contentPop">
                        <Grid container spacing={1}>
                            <Grid item xs={6}>
                                <FormControl>
                                    <label className="required" htmlFor="roleNameAdd">Role Name</label>
                                    <TextField id="roleNameAdd"
                                        variant="outlined"
                                        placeholder="Enter Role Name"
                                        name="roleNameAdd"
                                        defaultValue={roleNameAdd}
                                        onChange={handleChangeAddRole} />
                                    <div style={{ fontSize: 12, color: "red", fontFamily: "'Open Sans', sans-serif", marginTop: "1%" }}>{roleNameAddErr}</div>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl variant="outlined" >
                                <label className="required" htmlFor="roleNameAdd">Access Mode</label>
                                            <Select value={accessSite} 
                                                    onChange={handleChangeAddRole} 
                                                    name="accessSite" 
                                                    size="small" 
                                                    style={{fontSize:12,width:'100%'}}>
                                                    {gpsInstalledOptions.map((option) => (
                                                        <MenuItem key={option.id}
                                                                  style={{fontSize:12,width:'100%'}} 
                                                                  value={option.key}>
                                                                  {option.name}
                                                        </MenuItem>
                                                    ))}
                                            </Select>
                                            <div style={{fontSize:12,color:"white", fontFamily:"'Open Sans', sans-serif", marginTop:"1%"}}>{accessSiteErr} </div> 

                                         </FormControl>
                            </Grid>
                            </Grid>
                   
                </div>
            </div>      
        </DialogContent>
        <DialogActions >
        <Grid container spacing={1}>
        <Grid item xs={12}>

            <div  className="create_ulb_buttons" style={{marginBottom:'10px'}}>
            <Button autoFocus onClick={handleCloseAddRole} style={{
                background:'none',
                color:'#3dab35',
                border:" 1px solid rgba(61, 171, 53, 0.5)",
                }} 
                type="submit">{t("cancel")}
            </Button>
            <Button onClick={handleSubmitAddRole} style={{
                background:'#3dab35',
                color:'white',
                border:" 1px solid rgba(61, 171, 53, 0.5)",
                }}  autoFocus
                type="submit"
              
                >{ openIdPop !== ""? `${t("saveChange")}`: `${t("save")}`}
            </Button>
            </div>
        </Grid>
        </Grid>
           
        </DialogActions>
    </Dialog>
    </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return({
        token        : state.auth.token,
        userHeaders  : state.userHeaders.userHeaders.concat({header: "Action", accessor: "actionButton", sortable: "false", filter: "false"}),
        userData     : state.userData.userData,
        totalCount   : state.userData.totalCount,
        loadingUser : !!state && state.userData.loading,
        // roleData : state.roleData.roleData,
        roleData : state.roleData.roleData,
        totalCountRole: state.roleData.totalCount,
    })
}

const mapDispatchToProps = (dispatch) => {
    return({
        onFetchUserHeaders : (payload) => dispatch(actionCreators.fetchUserHeaders(payload)),
        onFetchUserListing : (payload) => dispatch(actionCreators.fetchUserListing(payload)),
        onDeleteUser       : (payload, data, props, t) => dispatch(actionCreators.deleteUser(payload, data, props, t)),
        onSearchUserName   : (payload, t) => dispatch(actionCreators.searchUserName(payload, t)),
        onFetchRole   : (payload) => dispatch(actionCreators.fetchRoleListing(payload)),
        onAddUser : (payload,props) => dispatch(actionCreators.addUser(payload,props)),
        onAddRole     : (payload, token) => dispatch(actionCreators.addRole(payload, token)),
        onDeleteRole  : (payload, payload2) => dispatch(actionCreators.deleteRole(payload, payload2)),
        onEditUser : (payload,props, t) => dispatch(actionCreators.editUser(payload,props, t))
        
    })
}

export default connect(mapStateToProps, mapDispatchToProps)(UserListing)



